/* eslint-disable quote-props */

export const available = {
  'checagem': 'Checagem',
  'análise': 'Análise',
  'pendente': 'Pendente',
  'pré_aprovada': 'Pré-aprovada',
  'recusada': 'Recusada',
  'restrição': 'Restrição',
  'desistencia': 'Desistência',
  'aprovada': 'Aprovada',
  'faturada': 'Faturada',
  'expirada': 'Expirada',
};

export const STATES = Object.keys(available).map(key => ({
  label: available[key],
  value: key,
}));

export default function status(value) {
  return available[value] || value;
}
